<template>
  <div
    class="accent d-flex flex-column justify-space-between"
    style="height: 100vh"
  >
    <div
      class="d-flex justify-space-between align-center darkgrey darken-4"
      :style="main"
    >
      <div style="width: 100px" class="pa-3">
        <v-btn icon class="d-flex" @click="$emit('close')">
          <v-icon color="white"> mdi-arrow-left </v-icon>
        </v-btn>
      </div>

      <div
        class="grey--text align-self-center text-center"
        style="width: 100px"
      >
        {{ currentImage + 1 + " of " + dialog.poi.images.length }}
      </div>
      <div class="" style="width: 100px"></div>
    </div>

    <v-carousel hide-delimiters v-model="currentImage" :continuous="false">
      <v-carousel-item v-for="image in dialog.poi.images" :key="image.id">
        <div class="d-flex align-center justify-center">
          <img
            :src="`https://efales.mobics.gr/images/${image.image[0].file_name}`"
            heigth="auto"
            width="auto"
          />
        </div>
      </v-carousel-item>
    </v-carousel>

    <div
      class="d-flex align-center justify-center darkgrey darken-4 pa-2"
      style="width: 100%"
    >
      <div v-for="(image, i) in dialog.poi.images" :key="image.id">
        <div
          v-if="i == currentImage"
          class="grey--text align-self-center text-center"
        >
          <!-- {{ "lorem" + i }} -->
          <!-- todo iamge desc -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    dialog: Object,
  },

  created() {
    this.currentImage = this.dialog.index;
  },

  data() {
    return {
      currentImage: {},
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
    }),
    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
        width: "100%",
      };
    },
  },

  methods: {},
};
</script>

<style>
</style>